import { OLD_APP_URL } from "app/api/config"
import { logout } from "app/api/oauth"
import styles from "./Shell.module.css"
import { logOut, oldAppUrl } from "./start"

// ponytail: Dutch only until the app shell brings react-intl and src/beta/i18n (design step 2)
export function Shell() {
  return (
    <main className={styles.shell}>
      <span className={styles.badge}>Beta</span>
      <h1 className={styles.title}>Docket</h1>
      <a className={styles.back} href={oldAppUrl(OLD_APP_URL)}>
        Terug naar het oude Docket
      </a>
      <button type="button" className={styles.logout} onClick={() => logOut(logout)}>
        Uitloggen
      </button>
    </main>
  )
}
